import { render, staticRenderFns } from "./MsTeamsStudent.vue?vue&type=template&id=432f9039&scoped=true&"
import script from "./MsTeamsStudent.vue?vue&type=script&lang=js&"
export * from "./MsTeamsStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432f9039",
  null
  
)

export default component.exports